import React from 'react';
import PropTypes from 'prop-types';
import {Button, Dialogue, IconButton, Dropdown, DropdownItem} from '@albert-io/atomic';
import {getModelForResourceType} from 'resources/modelRegistry';

import {query} from '@albert-io/json-api-framework/request/builder';
import {genericMandarkRequest, invalidatePartialInterest} from 'resources/mandark.resource';
import ManageRosterContext from 'client/Classrooms/Classroom/Teacher/ManageRoster/ManageRoster.context';
import ResetPasswordModal from 'client/components/ResetPasswordModal/ResetPasswordModal.react';

import ConfirmActionModal from 'client/components/ConfirmActionModal/ConfirmActionModal.react';

export default class EnrolledStudentsActionsDropdown extends React.PureComponent {
  static propTypes = {
    classroom: PropTypes.instanceOf(getModelForResourceType('classroom_v1')),
    student: PropTypes.instanceOf(getModelForResourceType('student_v2'))
  };

  constructor() {
    super();

    this.state = {
      showRemoveModal: false,
      showResetPasswordModal: false
    };
  }

  handleRemoveStudent = async () => {
    const {student} = this.props;
    await genericMandarkRequest(
      'delete',
      query()
        .mandarkEndpoint(['students_v2', student.getId(), 'relationships', 'classrooms_v1'])
        .done(),
      {
        data: [
          {
            id: this.context.classroom.getId()
          }
        ]
      }
    );
  };

  handleSuccess = () => {
    invalidatePartialInterest(this.context.queries.students.done());
    invalidatePartialInterest({resourcePath: this.context.queries.classroom.done().resourcePath});
    this.context.setIsReady(false);
  };

  static contextType = ManageRosterContext;

  render() {
    const {classroom, student} = this.props;
    const allowResetPassword = student.getMeta().isManagedUser();
    return (
      <>
        <Dropdown trigger={<IconButton icon='ellipsis-v' label='menu' />} position='bottom-end'>
          {allowResetPassword && (
            <DropdownItem
              as='button'
              icon={['fal', 'key']}
              onClick={() => this.setState({showResetPasswordModal: true})}
            >
              Reset password
            </DropdownItem>
          )}
          <DropdownItem
            as='button'
            className='items-center'
            color='red'
            icon='times'
            iconColor='negative'
            onClick={() => this.setState({showRemoveModal: true})}
          >
            Remove from class
          </DropdownItem>
        </Dropdown>
        {this.state.showRemoveModal && (
          <ConfirmActionModal
            align='center'
            handleClose={() => this.setState({showRemoveModal: false})}
            makeRequest={this.handleRemoveStudent}
            onResolve={this.handleSuccess}
          >
            {({isRequestInflight, onCancel, onConfirm}) => (
              <>
                <Dialogue.Body align='center'>
                  Are you sure you want to remove
                  <br />
                  <strong>
                    {student.getFullName()} ({student.getEmail()}) from
                  </strong>
                  <br />
                  <strong>{classroom.getName()}</strong>?
                </Dialogue.Body>
                <Dialogue.BtnGroup align='center'>
                  <Button color='secondary' disabled={isRequestInflight} onClick={onCancel}>
                    Cancel
                  </Button>
                  <Button
                    color='negative'
                    data-testid='remove-student-confirm-button'
                    disabled={isRequestInflight}
                    onClick={onConfirm}
                  >
                    Remove
                  </Button>
                </Dialogue.BtnGroup>
              </>
            )}
          </ConfirmActionModal>
        )}
        {this.state.showResetPasswordModal && (
          <ResetPasswordModal
            handleClose={() => this.setState({showResetPasswordModal: false})}
            student={student}
          />
        )}
      </>
    );
  }
}
